module.exports = __webpack_public_path__ + "img/email-sent.8332ad57.svg";